









import { Component, Vue } from 'vue-property-decorator'
import WarningForm from './WarningForm.vue'
import { Warning, AddWarning } from '../store/warning'
import { namespace } from 'vuex-class'
const warningStore = namespace('warning')
@Component({ components: { WarningForm } })
export default class AddWarningModal extends Vue {
  dialog = false
  @warningStore.Action add!: (sensor: AddWarning) => Promise<Warning>

  async addWarning(warning: AddWarning) {
    await this.add(warning)
    this.dialog = false
  }
}
